import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class SurveyService {
    async getSurveyList(sTitle, sStatus, sdate, edate) {
        return await axios
            .post(`/survey/all`, {
                survey_title: sTitle,
                survey_status: sStatus,
                start_date: sdate,
                end_date: edate,
            })
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async createSurvey(sTitle, surl, sdate, edate, s_status) {
        return await axios
            .post(`/survey`, {
                survey_title: sTitle,
                survey_url: surl,
                start_date: sdate,
                end_date: edate,
                status: s_status,
            })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async notifyUser(sId) {
        return await axios
            .post(
                `/survey/notify_survey
            `,
                {
                    survey_id: sId,
                }
            )
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async updateSurvey(sTitle, surl, sdate, edate, s_status, ids) {
        return await axios
            .patch(`/survey/${ids}`, {
                survey_title: sTitle,
                survey_url: surl,
                start_date: sdate,
                end_date: edate,
                status: s_status,
            })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async getExcel(sTitle, sStatus, sdate, edate,dreason) {
        return await axios({
            url: `/survey/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                survey_title: sTitle,
                survey_status: sStatus,
                start_date: sdate,
                end_date: edate,
                reason:dreason,
            },
        })
            .then((res) => res)
            .catch((err) => {
                errCheck(err);
            });
    }
    async survyDetails(ids) {
        return await axios
            .get(`/survey/${ids}`)
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
}
